<template>
    <meilisearch-search
        :index="index"
        v-bind="$props"
        v-on="$listeners"
    >
        <template v-slot:next-to-search="{ typing }">
            <div class="self-end md:self-auto flex">
                <v-spa-loading-button
                    :color="buttonColor"
                    :prevent-default="true"
                    extra-class="md:py-2 mr-2"
                    @clicked="showEditContactForm(typing)"
                    v-if="value"
                >
                    <i class="fas fa-edit"></i>
                </v-spa-loading-button>
                <v-spa-loading-button
                    :color="buttonColor"
                    :prevent-default="true"
                    extra-class="md:py-2"
                    @clicked="showCreateContactForm(typing)"
                >
                    {{ $t('components.meilisearch.contacts.search.buttons.add') }}
                </v-spa-loading-button>
            </div>
        </template>
    </meilisearch-search>
</template>

<script>
import setup from '@spa/setup';
import { MeilisearchSearch, searchMixinProps } from "../Search";
import { searchContactFormMixinProps } from "./mixin";
const { index, ...mixinProps } = searchMixinProps;
export default {
    components: { MeilisearchSearch },
    props: {
        ...mixinProps,
        ...searchContactFormMixinProps
    },
    data() {
        return { 
            index: setup.meilisearch.indexes.contact.contacts,
            typing: {}
        }
    },
    methods: {
        showCreateContactForm(typing) {
            setup.bus.$emit('contacts.create', this.onCreate({
                onInit: (contact) => {
                    contact.name = typing.bind.value;
                    return contact;
                }
            }));
            this.typing = typing;
        },
        showEditContactForm(typing) {
            setup.bus.$emit('contacts.edit', this.onEdit({
                uuid: this.value.uuid
            }));
            this.typing = typing;
        },
        /**
         * Updating v-model when contact is stored.
         * @type {import("@henrotaym/vue-event-bus").EventBusListener<'contacts.stored', import("@spa/types/bus").PackageEventBusEvents>}
         */
        stored(params) {
            this.changed(params.contact);
        },
        /**
         * Updating v-model when contact is updated.
         * @type {import("@henrotaym/vue-event-bus").EventBusListener<'contacts.updated', import("@spa/types/bus").PackageEventBusEvents>}
         */
        updated(params) {
            this.changed(params.contact);
        },
        /**
         * Changing typing and value based on given contact.
         * @param {import('@spa/types/api/app/contact').ContactInterface} contact
         */
        changed(contact) {
            this.typing.set(contact.name);
            this.$emit('input', contact);
        }
    },
    computed: {
        buttonColor() {
            return setup.css.button.color.gray;
        },
    },
    created() {
        setup.bus.$on('contacts.stored', this.stored);
        setup.bus.$on('contacts.updated', this.updated);
    }
}
</script>